var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":"https://gitee.com/xqnode/images/raw/master/imgs/微信.png","width":"300"}})])
}]

export { render, staticRenderFns }